import { ExhibitorInspector } from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { exhibitorInspectorKeys } from "../query-keys";

export const useGetExhibitorInspectorByExhibitorIdQuery = (
  exhibitorId: string,
  eventId: string,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: exhibitorInspectorKeys.byExhibitorId(exhibitorId, eventId),
    queryFn: async (): Promise<ExhibitorInspector> => {
      const response = await privateAxios.get(
        `/exhibitor-inspector/exhibitor/${exhibitorId}/event/${eventId}`
      );
      return response.data;
    },
    enabled: options?.enabled ?? !!exhibitorId,
  });
};
